import { ExternalLink, MapPin } from 'lucide-react';
import { GOOGLE_MAPS_URL } from './constants';

type Props = {
	latitude: number;
	longitude: number;
};

export default function ViewOnGoogleMaps({ latitude, longitude }: Props) {
	const googleMapsUrl = `${GOOGLE_MAPS_URL}?q=${latitude},${longitude}`;

	return (
		<div className="flex items-center">
			<a
				href={googleMapsUrl}
				target="_blank"
				rel="noopener noreferrer"
				className="text-xs flex items-center gap-1 text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
			>
				<MapPin className="h-3 w-3" />
				View on Google Maps
				<ExternalLink className="h-3 w-3" />
			</a>
		</div>
	);
}
